import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=43c11e95&scoped=true"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=43c11e95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c11e95",
  null
  
)

export default component.exports